import { render } from "./CardView.vue?vue&type=template&id=41797848"
import script from "./CardView.vue?vue&type=script&lang=js"
export * from "./CardView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\luke\\Desktop\\Bod_registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__